import { useEffect, useLayoutEffect, useRef, useState } from "react";
import "./LanguageSwitcher.css";

const LANGS = [
  { code: "it", label: "IT", flag: "🇮🇹" },
  { code: "en", label: "EN", flag: "🇬🇧" },
  { code: "fr", label: "FR", flag: "🇫🇷" },
  { code: "es", label: "ES", flag: "🇪🇸" },
  { code: "de", label: "DE", flag: "🇩🇪" },
];

export default function LanguageSwitcher({ value = "it", onChange }) {
  const [active, setActive] = useState(value);
  const [bubble, setBubble] = useState({ x: 0, w: 0, ready: false });
  const btnRefs = useRef({});

  const measure = (code) => {
    const el = btnRefs.current[code];
    if (el) setBubble((b) => ({ x: el.offsetLeft, w: el.offsetWidth, ready: b.ready }));
  };

  useLayoutEffect(() => {
    measure(active);
    requestAnimationFrame(() => setBubble((b) => ({ ...b, ready: true })));
  }, []);

  useEffect(() => {
    const onResize = () => measure(active);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [active]);

  useEffect(() => { setActive(value); measure(value); }, [value]);

  const select = (code) => {
    setActive(code);
    measure(code);
    onChange && onChange(code);
  };

  return (
    <div className="lang-switch" role="tablist" aria-label="Lingua">
      <span
        className={`lang-bubble ${bubble.ready ? "is-ready" : ""}`}
        style={{ width: bubble.w, transform: `translateX(${bubble.x}px)` }}
      />
      {LANGS.map((l) => (
        <button
          key={l.code}
          ref={(el) => (btnRefs.current[l.code] = el)}
          role="tab"
          aria-selected={active === l.code}
          className={`lang-btn ${active === l.code ? "is-active" : ""}`}
          onClick={() => select(l.code)}
          data-testid={`lang-${l.code}`}
        >
          <span className="lang-flag">{l.flag}</span>
          <span className="lang-abbr">{l.label}</span>
        </button>
      ))}
    </div>
  );
}
